// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiIndividual {
    static getAttributeTypeMap() {
        return MedicalBiIndividual.attributeTypeMap;
    }
}
MedicalBiIndividual.discriminator = undefined;
MedicalBiIndividual.additionalProperties = false;
MedicalBiIndividual.attributeTypeMap = [
    {
        "name": "deductibleMet",
        "baseName": "deductibleMet",
        "type": "number"
    },
    {
        "name": "deductibleTotal",
        "baseName": "deductibleTotal",
        "type": "number"
    },
    {
        "name": "oopMax",
        "baseName": "oopMax",
        "type": "number"
    },
    {
        "name": "oopMet",
        "baseName": "oopMet",
        "type": "number"
    },
];
//# sourceMappingURL=medicalBiIndividual.js.map